import {
  Box,
  BoxProps,
  Text,
} from '@chakra-ui/react';

type TitleProps = {
  title: string;
  subTitle?: string;
  isClosed?: boolean;
} & BoxProps;

export const Title = ({
  title,
  subTitle,
  isClosed = false,
  ...rest
}: TitleProps) => {
  return (
    <Box
      {...rest}
      textAlign={'justify'}
    >
      <Text
        textStyle={{ base: 'h2', lg: 'h2' }}
        fontWeight={'bold'}
        as={'h1'}
        pt={3}
      >
        {isClosed &&
          <Text
            as="span"
            color={'red.500'}
            fontWeight={'bold'}
            textStyle={'h2'}
            mr={2}
          >
            [閉店]
          </Text>
        } 
        {title}

        {subTitle && (
          <Text
            textStyle={'h1'}
            fontWeight={'bold'}
            letterSpacing={'0.13em'}
            whiteSpace={'pre-line'}
            color={'brand.500'}
          >
            {subTitle}
          </Text>
        )}
      </Text>
    </Box>
  );
};
